import { IssuesGrid } from '@rdrive/plugin-items-grid';
import { TotalAndAssignedCards } from '@rdrive/plugin-total-cards';
import { StackedHorizontalBarChart } from '@rdrive/plugin-chart-stacked-bar';
import { BaseGanttChart } from '@rdrive/plugin-gantt';
import setup from './setup.js';

export default {
  name: 'drawings-page',
  components: { IssuesGrid, TotalAndAssignedCards, StackedHorizontalBarChart, BaseGanttChart },
  setup,
};
